import * as React from 'react';

import { getProductView_productDetailByMasterId_variants } from '../../queries/__generated__/getProductView';
import { getModifaceVariants } from '../utils';

export const useModifaceVariants = (
  variants: getProductView_productDetailByMasterId_variants[]
) => {
  return React.useMemo(() => getModifaceVariants(variants), [variants]);
};
